export const AppSubscriptionsActivationTypes = {
    MANUAL: "Manual",
    AUTOMATIC: "Automatic"
  };

export const AppSubscriptionsActivationStates = {
  PENDING: "Pending",
  ACTIVE: "Active",
  DENIED: "Denied"
}
